import { useCallback, useEffect, useState } from "react";
import { getSlaSettings, DEFAULT_SLA_SETTINGS } from "@/api/slaSettingsApi";

/**
 * Workspace SLA thresholds + tick for inbox breach highlights.
 */
export function useSlaSettings(tickMs = 10000) {
  const [settings, setSettings] = useState(() => ({ ...DEFAULT_SLA_SETTINGS }));
  const [now, setNow] = useState(() => Date.now());

  const reload = useCallback(async () => {
    const { data } = await getSlaSettings();
    setSettings(data ?? { ...DEFAULT_SLA_SETTINGS });
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "tenant-admin:sla-settings:v1" || e.key === null) void reload();
    };
    const onCustom = () => void reload();
    window.addEventListener("storage", onStorage);
    window.addEventListener("sla-settings-changed", onCustom);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("sla-settings-changed", onCustom);
    };
  }, [reload]);

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), tickMs);
    return () => window.clearInterval(id);
  }, [tickMs]);

  return { settings, now, reload };
}
